export default __webpack_public_path__ + "static/media/jericoacoara.020e0197.jpeg";